export default function UpgradePrompt () {
    return (
        <div id="upgradePage">
            <p><a href="https://billing.stripe.com/p/login/6oEaHXdRx3KAcYU5kk" target="_blank">Upgrade</a>&nbsp;your subscription to access this page.</p>
        </div>
    )
}
